/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export default {
  indigo_10: '#e3e3fa',
  indigo_20: '#cacafa',
  indigo_30: '#adadf7',
  indigo_40: '#8d8df2',
  indigo_50: '#6c6ceb',
  indigo_60: '#4c4ce0',
  indigo_70: '#3737d3',
  indigo_80: '#2c2abd',
  indigo_90: '#2621a6',
  indigo_100: '#201d8f',

  a11y_text_light: [60, 70, 80, 90, 100]
};



// WEBPACK FOOTER //
// ./src/colors/indigo.js